import { configureStore } from '@reduxjs/toolkit';
import configReducer from './configSlice';
import applicationReducer, { 
  selectApplications, 
  selectApplicationsPagination, 
  selectApplicationsLoading, 
  selectApplicationsError,
  fetchApplications
} from './applicationSlice';
import authReducer from './authSlice';
import auditLogReducer from './auditLogSlice';

const store = configureStore({
  reducer: {
    config: configReducer,
    applications: applicationReducer,
    auth: authReducer,
    auditLog: auditLogReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['config/updateRule', 'config/addRule', 'config/updateSmeRule', 'config/addSmeRule', 'applications/addApplication'],
        ignoredPaths: ['config.rules', 'config.smeRules', 'applications.applications'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Export selectors and actions
export { selectApplications, selectApplicationsPagination, selectApplicationsLoading, selectApplicationsError, fetchApplications };

export default store; 